module.exports = __webpack_public_path__ + "static/media/qr-code.651b5eb8.png";